import { Box, DialogContent } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import React, { ReactNode } from 'react';
import { SubmitHandler, UseFormReturn } from 'react-hook-form';
import KSimHeader from '../../k-sim-header/KSimHeader';
import StudentsFormFields from '../../students-form-fields/StudentsFormFields';
import { Simulator } from '../../types';
import { useActiveCompany } from '../../utils/useCompany';
import { AdHocExerciseFormData } from './CreateAdHocExerciseDialog';

export type StudentsStepProps = UseFormReturn<AdHocExerciseFormData> & {
  actions?: ReactNode;
  handleNext: SubmitHandler<AdHocExerciseFormData>;
  stepper?: ReactNode;
  isLoading?: boolean;
};

const StudentsStep = ({
  actions,
  clearErrors,
  handleNext,
  handleSubmit,
  watch,
  setValue,
  stepper,
}: StudentsStepProps) => {
  const activeCompany = useActiveCompany();
  const { data: simulators } = useQuery<Simulator[]>({
    enabled: !!activeCompany,
    queryKey: [{ path: `teach/companies/${activeCompany?.companyId}/simulators` }],
  });

  const simulatorType = simulators?.find(simulator => simulator.id === watch('simulator'))?.type;

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(handleNext)}
      noValidate
      autoComplete="off"
      sx={{ display: 'contents' }}
    >
      <DialogContent>
        {stepper}
        <Box display="flex" flexDirection="column" gap={3}>
          <KSimHeader
            adHoc
            exerciseType={watch('type')}
            mobileOnly
            simulatorType={simulatorType}
            sx={{ height: '153px' }}
          />

          <StudentsFormFields
            onUpdate={users => {
              clearErrors('users');
              setValue('users', users);
            }}
            value={watch('users')}
            simulatorId={watch('simulator')}
          />
        </Box>
      </DialogContent>

      {actions}
    </Box>
  );
};

export default StudentsStep;
